import {makeStyles} from "@material-ui/core/styles";

export const useFilterHistoryStyles = makeStyles(() => ({
    filterChip: {
        margin: "0.25em",
        "& > .MuiChip-deleteIcon": {
            display: "block !important"
        }
    }
}));
